import styles from "./styles.module.scss";
import { FC, IOption, Props } from "./typings";

const Menu = ({
  options,
  createText,
  onCreate,
}: {
  options: IOption[];
  createText?: string;
  onCreate?(): void;
}) => {
  return (
    <div className={styles.menu}>
      <div className={styles.menuWrapper}>
        {options?.map((option, index) => (
          <div
            onClick={option.callback}
            key={index}
            className={`${styles.box} ${option.isActive && styles.activeText}`}
          >
            {option.label}
          </div>
        ))}
      </div>
      {createText && (
        <div onClick={onCreate} className={styles.button}>
          {createText}
        </div>
      )}
    </div>
  );
};

const GridWindow: FC<Props> = ({
  title,
  options,
  children,
  createText,
  onCreate,
}) => {
  return (
    <div className={styles.window}>
      <div className={styles.wrapper}>
        {options && (
          <Menu createText={createText} onCreate={onCreate} options={options} />
        )}
        {title && (
          <div className={styles.title}>
            <div className={styles.header}>{title}</div>
            {createText && (
              <div onClick={onCreate} className={styles.button}>
                {createText}
              </div>
            )}
          </div>
        )}
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};

export default GridWindow;
